<template>
  <v-card>
    <v-card-text>
      <v-data-table
        :headers="tableColumns"
        :items="scheduledCampaigns"
        item-key="schedule_id"
        group-by="scheduled_date"
        dense
      >
        <template v-slot:group.header="{items, isOpen, toggle}">
          <th colspan="100%">
            <v-btn text icon small color="white" @click="toggle">
              <v-icon>{{ isOpen ? 'mdi-minus' : 'mdi-plus' }}</v-icon>
            </v-btn>
            <span class="mx-2 text-subtitle-1">{{ groupTitle(items[0].scheduled_at) }}</span>
          </th>
        </template>
        <template v-slot:item.name="{ item } ">
          <a href="#" @click.prevent="$emit('edit-campaign', item)">{{ item.name }}</a>
        </template>
        <template v-slot:item.scheduled_time="{ item }">
          {{ campaignToLocalTime(item) }}
        </template>
        <template v-slot:item.schedule_type="{ item }">
          <v-icon :color="scheduleTypeColor(item.schedule_type)">{{ scheduleTypeIcon(item.schedule_type) }}</v-icon>
          {{ item.schedule_type | capitalize }}
        </template>
      </v-data-table>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapState } from 'vuex'
import ScheduleTypeHelperMixin from './ScheduleTypeHelperMixin'
import { SearchFilterMixin } from '@/components/mixins'
import * as R from 'ramda'
import { DateTime } from 'luxon'

export default {
  name: 'scheduled-email-campaigns-list',
  mixins: [ScheduleTypeHelperMixin, SearchFilterMixin],
  props: {
    allDealers: {
      required: true,
      type: Boolean,
      default: false
    },
    showDealersColumn: {
      required: false,
      type: Boolean,
      default: true
    },
    propsToSearch: {
      required: false,
      type: Array,
      default: function () { return [] }
    },
    searchTerm: {
      require: false,
      type: String,
      default: ''
    },
    scheduledCampaignsData: {
      required: true,
      type: Array
    }
  },
  data () {
    return {
      colList: [ { text: 'Name', value: 'name' },
        { text: 'Dealer', value: 'dealer_name' },
        { text: 'Schedule Type', value: 'schedule_type' },
        { text: 'Scheduled Date', value: 'scheduled_date' },
        { text: 'Scheduled Time', value: 'scheduled_time' }
      ],
      actions: [
        { title: 'Edit', action: 'edit', icon: 'mdi-pencil' },
        { title: 'View Report', action: 'show', icon: 'mdi-file-chart' },
        { title: 'Delete', action: 'handleDelete', icon: 'mdi-delete' }
      ]

    }
  },
  computed: {
    ...mapState('DealerStore', ['dealer']),
    // ...mapState('EmailCampaignStore', { scheduledCampaignsData: 'scheduledCampaigns' }),
    // filtered campaigns...
    scheduledCampaigns () {
      return this.filterDataBySearchTerm(this.searchTerm, this.propsToSearch, this.scheduledCampaignsData)
    },
    tableColumns: function () {
      const dlrColFilter = this.showDealersColumn ? R.always(this.colList) : R.reject(R.propEq('value', 'dealer_name'))
      return dlrColFilter(this.colList)
    }
  },
  methods: {
    campaignToLocalTime (scheduleData) {
      const t = DateTime.fromISO(scheduleData.scheduled_at)
      return `${t.toLocaleString(DateTime.TIME_SIMPLE)} (${t.toRelativeCalendar({ base: DateTime.now() })})`
    },
    groupTitle (eventDateTime) {
      // for eventDateTime, use a DateTime because if you just use a date, it does not account for timezones
      return DateTime.fromISO(eventDateTime).toLocaleString(DateTime.DATE_HUGE)
    }
  }
}
</script>
